import angular from 'angular';

angular
  .module('cxHttpServices')
  .factory('interactionTemplateHttpSvc', [
    '$http',
    '$q',
    'appUrls',
    'checkSecurity',
    interactionTemplateHttpSvc,
  ]);

function interactionTemplateHttpSvc($http, $q, appUrls, checkSecurity) {
  var baseUrl = appUrls.api + '/api/InteractionTemplate/';

  function handleSuccess(response) {
    return response.data;
  }

  return {
    getTemplates: function(type) {
      return $http.get(baseUrl + 'Company/' + type).then(handleSuccess);
    },
    getTemplate: function(templateId) {
      return $http.get(baseUrl + 'Get/' + templateId).then(handleSuccess);
    },
    getContent: function(templateId, lang) {
      return $http
        .get(baseUrl + 'Content/' + templateId + '/' + (lang || 'nl'))
        .then(handleSuccess);
    },
    getTemplateWithContent: function(templateId) {
      return $http.get(baseUrl + 'Get/' + templateId).then(function(response) {
        var template = response.data;

        // if the template contains interaction tags, retrieve their respective name and attach them to the template
        var interactionTagsPromise =
          template.interactionTags && template.interactionTags.length && checkSecurity(['Settings:u', 'EmailAndInteractionTemplates:u']) // tags are only relevant if user can edit the template
            ? $http.get(appUrls.interactions + '/api/tags').then(function({ data }) {
                if (data && data.length) {
                  template.interactionTags = data.filter(x =>
                    template.interactionTags.includes(x.id),
                  );
                }
                return template;
              })
            : undefined;

        var promises = template.languages.map(function(lang) {
          return $http
            .get(baseUrl + 'Content/' + templateId + '/' + (lang.languageCode || 'nl'))
            .then(function(response) {
              lang.content = response.data.content;
              lang.title = response.data.title;
              return lang;
            });
        });

        promises = [...promises, interactionTagsPromise];

        return $q.all(promises).then(function() {
          return template;
        });
      });
    },
    createTemplate: function(companyId, template) {
      return $http.post(baseUrl + 'Template/' + companyId, template).then(handleSuccess);
    },
    copyTemplate: function(templateId) {
      return $http.post(baseUrl + 'Copy/' + templateId).then(handleSuccess);
    },
    updateTemplate: function(template) {
      return $http.put(baseUrl + 'Template', template).then(handleSuccess);
    },
    removeTemplate: function(templateId) {
      return $http.delete(baseUrl + 'Template/' + templateId).then(handleSuccess);
    },
    createLanguage: function(templateId, language) {
      return $http.post(baseUrl + 'CreateLanguage/' + templateId, language).then(handleSuccess);
    },
    updateLanguage: function(templateId, language) {
      return $http.put(baseUrl + 'UpdateLanguage/' + templateId, language).then(handleSuccess);
    },
    removeLanguage: function(templateId, languageId) {
      return $http
        .delete(baseUrl + 'Language/' + templateId + '/' + languageId)
        .then(handleSuccess);
    },
  };
}
